import axios from 'axios';
import _ from "lodash";
import {supabaseDataService} from "@/services/supabaseService.js";

const API_URL = import.meta.env.VITE_API_URL;
const bearerToken = import.meta.env.VITE_KNOKO_BEARER_TOKEN;

// Create axios instance with base URL
const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
});

apiClient.interceptors.request.use(async (config) => {
    config.headers.Authorization = `Bearer ${bearerToken}`;
    return config;
});

export const iCloudService = {
    getUserCredentials: async (uid, iCloudUrl) => {
        try {
            const payload = {
                uid: uid,
                action: 'getUserCredentials'
            };

            const response = await apiClient.post(iCloudUrl, payload);

            return response.data;
        } catch (error) {
            console.error('Error connecting to icloud service:', error);
            throw error;
        }
    },

    connectToICloud: async (iCloudEmail, iCloudPassword, iCloudUrl) => {
        try {
            const payload = {
                iCloudEmail: iCloudEmail,
                iCloudPassword: iCloudPassword,
                action: 'testConnection'
            };

            console.log('--payload--->', payload);
            const response = await apiClient.post(iCloudUrl, payload);

            console.log('response.data;----->',response.data);

            return response.data;
        } catch (error) {
            console.error('Error connecting to icloud service:', error);
            throw error;
        }
    },

    resetICloud: async (uid, iCloudUrl) => {
        try {
            const payload = {
                action: 'resetICloud',
                uid: uid,
            };

            console.log('--payload--->', payload);
            const response = await apiClient.post(iCloudUrl, payload);

            console.log('response.data;----->',response.data);

            return response.data;
        } catch (error) {
            console.error('Error disconnecting from icloud service:', error);
            throw error;
        }
    },

    syncICloud: async (uid, iCloudUrl, iCloudEmail, iCloudPassword, saveToDatabase = false, startDate, endDate, calendarsToSync, saveCreds) => {
        try {
            console.log('--[syncICloud]--->',calendarsToSync);

            // Support both a single calendar object and an array of calendars
            const calendars = Array.isArray(calendarsToSync)
                ? calendarsToSync.map(cal => ({ calendarId: cal.id, calendarName: cal.name }))
                : [{ calendarId: calendarsToSync.id, calendarName: calendarsToSync.name }];

            const payload = {
                iCloudEmail: iCloudEmail,
                iCloudPassword: iCloudPassword,
                saveToDatabase: saveToDatabase,
                action: 'syncEvents',
                uid: uid,
                startDate: startDate,
                endDate: endDate,
                calendars: calendars,
                saveCreds: saveCreds
            };

            console.log('--payload--->', payload);
            const response = await apiClient.post(iCloudUrl, payload);

            console.log('response.data;----->',response.data);

            return response.data;
        } catch (error) {
            console.error('Error connecting to icloud service:', error);
            throw error;
        }
    }

};
